import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { ImmovableBlock } from '../../components/generaldata/generaldatapages/immovable'; 
import { Layout } from "antd";
import { useParams } from 'react-router-dom';

const { Content } = Layout;

const ImmovablePage: FC = () => {
    const { alias } = useParams<{alias: string}>();
    const {t} = useTranslation();

    if (!alias) {
        return <div> alias не найден </div>
    }

    return (
        <>
            <Helmet>
                <title>{t("Недвижимость")}</title>
            </Helmet>
            
                <ImmovableBlock alias={String(alias)}/>
                
            
        </>
    );
};

export default ImmovablePage
